/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_TagsInputs */



/**
* | output |
* | --- |
* | "Include Tags" |
*
* @param {Transcript_Export_Include_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_tags = /** @type {((inputs?: Transcript_Export_Include_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Tags")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Tags")
	return /** @type {LocalizedString} */ ("Include Tags")
});